import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import type { RevenueShareReportsListRow } from "@/admin/entities/revenueShareReports";
import type { RevenueShareReportsListQueryType } from "@/types/graphql/admin.generated";
import {
  EXCHANGE_RATE_SOURCE_LABEL,
  RecalculateRevenueShareReportButton,
  RevenueShareReportColumns,
  formatDay,
} from "@/admin/features/billing";
import { ReportCorrections } from "./ReportCorrections";

export function getTableData(data: unknown): {
  nodes: RevenueShareReportsListRow[];
  count: number;
} {
  const typed = data as RevenueShareReportsListQueryType;
  const result = typed?.revenueShareReports;
  if (!result?.nodes) return { nodes: [], count: 0 };
  return { nodes: result.nodes, count: result.count };
}

export function mapColumns(report: RevenueShareReportsListRow) {
  return [
    report.id,
    report.period,
    report.status,
    report,
    report,
    report,
    report,
    report,
    report,
    report,
  ];
}

export const getColumnsConfig = () => [
  { name: "id", label: "ID", options: { display: false, filter: false } },
  RevenueShareReportColumns.buildPeriodColumn(),
  RevenueShareReportColumns.buildStatusColumn(),
  RevenueShareReportColumns.buildSalesColumn(),
  RevenueShareReportColumns.buildProviderFeeColumn(),
  RevenueShareReportColumns.buildFeeColumn(),
  {
    name: "refunds",
    label: "Возвраты и диспуты",
    options: {
      sort: false,
      customBodyRender: (data: unknown) => {
        const report = data as RevenueShareReportsListRow;
        return (
          <Stack spacing={0.5}>
            <RevenueShareReportColumns.MoneyAmountCell
              amount={report.refundsAmount}
              trailing={`${report.refundsCount} возв.`}
            />
            <RevenueShareReportColumns.MoneyAmountCell
              amount={report.disputesAmount}
              trailing={`${report.disputesCount} дисп.`}
            />
          </Stack>
        );
      },
    },
  },
  RevenueShareReportColumns.buildTotalColumn(),
  {
    name: "exchangeRate",
    label: "Курс",
    options: {
      sort: false,
      customBodyRender: (data: unknown) => {
        const report = data as RevenueShareReportsListRow;
        if (!report.exchangeRate) return "";
        const source =
          EXCHANGE_RATE_SOURCE_LABEL[report.exchangeRate.source] ??
          report.exchangeRate.source;
        return (
          <Stack>
            <Typography variant="body2">{report.exchangeRate.rate}</Typography>
            <Typography variant="caption" color="textSecondary">
              {formatDay(report.exchangeRate.date)}, {source}
            </Typography>
          </Stack>
        );
      },
    },
  },
  {
    name: "corrections",
    label: "Корректировки",
    options: {
      sort: false,
      customBodyRender: (data: unknown) => {
        const report = data as RevenueShareReportsListRow;
        return (
          <Stack spacing={1} sx={{ minWidth: 280 }}>
            <ReportCorrections report={report} />
            {report.status === "draft" && (
              <RecalculateRevenueShareReportButton reportId={report.id} />
            )}
          </Stack>
        );
      },
    },
  },
];

export const getTextsConfig = () => ({
  filterTitle: "Фильтры",
  listTitle: "Отчёты доли с продаж",
  refetchList: "Обновить список",
  cancel: "Отмена",
  editItem: "Отчёт",
  showTitle: "Детали",
});
